import getDateMonthYear from '@anm/helpers/date/getDateMonthYear'

export default (dateMs: number) => {
  const [prevDate, prevMonth, prevYear] = getDateMonthYear(dateMs);

  return new Date(prevYear, prevMonth - 1, prevDate).getTime();
};